import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icon/cancel-red.png'
import _imports_1 from '@/assets/img/icon/save-blue.png'
import _imports_2 from '@/assets/img/icon/edit-blue.svg'


const _hoisted_1 = {
  id: "test",
  class: "table-plotting"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 0,
  class: "text-green text-sm font-semibold"
}
const _hoisted_5 = {
  key: 1,
  class: "text-primary text-sm font-semibold"
}
const _hoisted_6 = {
  key: 2,
  class: "text-orange-1 text-sm font-semibold"
}
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = {
  key: 0,
  class: "pi pi-times text-red-600 font-bold text-xl ml-6"
}
const _hoisted_9 = {
  key: 1,
  class: "pi pi-times-circle text-red-600 font-bold text-xl ml-6"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Atur Snack ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down text-xs" }, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["title"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_18 = { class: "text-red-600" }
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "flex items-center gap-3" }
const _hoisted_22 = {
  key: 0,
  class: "inline-flex gap-3",
  style: {"width":"100px"}
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "edit-box"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-primary font-semibold" }, "Edit", -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Atur ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down text-black ml-4" }, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "px-4 py-3 bg-neutral-100 border-y border-neutral-200" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_34 = { class: "text-sm font-semibold" }
const _hoisted_35 = { class: "text-sm" }
const _hoisted_36 = { class: "text-sm" }
const _hoisted_37 = { class: "text-sm" }
const _hoisted_38 = { class: "flex items-center gap-2" }
const _hoisted_39 = { class: "font-normal text-sm text-grey" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "font-normal text-sm text-grey" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn-detail opacity-50 cursor-not-allowed",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Lihat Detail"),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" })
], -1)
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, "Lihat Detail", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  class: "w-full my-4",
  style: {"height":"150px","max-height":"200px","overflow-y":"auto"}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-full grid grid-cols-2 gap-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "Nopol"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "PP")
], -1)
const _hoisted_49 = { class: "text-center text-grey text-base font-normal" }
const _hoisted_50 = { class: "text-center text-grey text-base font-normal" }

import {
  reactive,
  ref,
  toRefs,
  computed,
  getCurrentInstance,
  onMounted
} from 'vue'
import type { PropType } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import { IPlotting } from '@/utils/interfaces/iPlotting'
import Paginator from '@/views/components/paginator/Paginator.vue'
import { PageState } from 'primevue/paginator'
import * as yup from 'yup'
import ListActions from '@/views/components/list/ListActions.vue'
import HjpAlertModal from '@/views/components/modal/HjpAlertModal.vue'
import OverlayPanel from 'primevue/overlaypanel'
import moment from 'moment'
import Popper from 'vue3-popper'
import { isNullOrEmptyString } from '@devexpress/analytics-core/analytics-internal'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import InfoScheduleDialog from '@/views/pages/roster/airport/component/infoScheduleDialog.vue'
import { checkProhibitedRoles } from '@/utils/helpers/checkProhibitedRole'
import SelectAsyncOpen from '@/views/components/form/SelectAsyncOpen.vue'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import numberFormat from '@/utils/helpers/numberFormat'
import { isNull } from 'lodash'
import { useRosterPositions } from '@/composables/pages/roster/useRosterPositions'
import RosterDetailActions from './action-list/RosterDetailActions.vue'
import RosterSnackActions from './action-list/RosterSnackActions.vue'

type TSchemaRowForm = yup.InferType<typeof schemaRowForm>


export default /*#__PURE__*/_defineComponent({
  __name: 'TableRoster',
  props: {
  plottingList: {
    type: Array as PropType<Array<IPlotting>>,
    default: () => []
  },
  isEdit: {
    type: Boolean,
    default: true
  },
  isRosterX: {
    type: Boolean,
    default: false
  },
  totalRecords: {
    type: Number,
    default: 0
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  dateFilter: {
    type: Date,
    default: null
  }
},
  emits: ["submit", "changePage", "onChangeStatusRoster", "onChangeVehicleRoster", "onDeactiveRoster", "onChangeStatusActiveRoster", "onResetRoster"],
  setup(__props, { emit }: { emit: ({
  (event: 'submit', param: any): void
  (event: 'changePage', param: PageState): void
  (event: 'onChangeStatusRoster'): void
  (event: 'onChangeVehicleRoster'): void
  (event: 'onDeactiveRoster'): void
  (event: 'onChangeStatusActiveRoster'): void
  (event: 'onResetRoster'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const {
  isEdit,
  isRosterX,
  totalRecords,
  isLoading,
  dateFilter
} = toRefs(props)

const plottingList = computed(() => props.plottingList)
const filterDate = computed(() => moment(props.dateFilter.toDateString()).format('YYYY-MM-DD'))

const calculateDropdownPosition = (dropdownList: any, component: any, { width, top, left }: any) => {
  dropdownList.style.position = 'absolute'
  dropdownList.style.left = left
  dropdownList.style.width = width
  dropdownList.style.zIndex = '9999'
  dropdownList.style.backgroundColor = '#ffffff'
  dropdownList.style.border = '1px solid #cbd5e1'
  dropdownList.style.borderRadius = '8px'
  dropdownList.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)'

  const toggleRect = component.$refs.toggle ? component.$refs.toggle.getBoundingClientRect() : null
  if (toggleRect) {
    const spaceBelow = window.innerHeight - toggleRect.bottom
    const dropdownHeight = 260
    if (spaceBelow < dropdownHeight && toggleRect.top > dropdownHeight) {
      const scrollY = window.scrollY || window.pageYOffset
      dropdownList.style.top = `${scrollY + toggleRect.top - dropdownHeight}px`
      dropdownList.style.maxHeight = `${Math.min(dropdownHeight, toggleRect.top - 10)}px`
      return
    }
  }
  dropdownList.style.top = top
}
const isRoster = ref(false)
const { positionIds, loadPositionIds } = useRosterPositions()
const endpoint = 'roster/v1/Roster'
const endpointTransactionPp = 'transaction/v1/TransactionPp'
const snackEndpoint = '/ticket/v1/Snacks'
const moduleStore = 'plotting'
const selectedDataForReturnSnack = ref(null) as any
const schemaRowForm = yup.object().shape({
  conductor: yup.object().required(),
  driver: yup.object().required(),
  // helper: yup.object()
})

const app = getCurrentInstance()
const {
  $icon,
  $toast
} = app!.appContext.config.globalProperties
const dataRow = ref(null) as any
const refOverlayAction = ref()
const refOverlayActionDetail = ref()
const refOverlayActionSnack = ref()
const editRosterTitle = ref('Edit')
const changeStatusRosterTitle = ref('Ganti Status')
const changeVehicleRosterTitle = ref('Ganti Kendaraan')
const resetRosterTitle = ref('Reset')
const currentSchedules = ref([]) as any
const isValidCondectur = ref(true)
const expandedRowsList = ref([])
const expandedRowListData = ref([])
const showScheduleDialog = ref(false)
const showConfirmResetDialog = ref(false)
const selectedRit = ref(null) as any
const defaultGuid = ref('00000000-0000-0000-0000-000000000000')
const defaultEditTimeout = ref(0)

const store = useStore()
const router = useRouter()
const plottingSelected = ref(null) as any

const rowForm = reactive({
  conductor: null as any,
  driver: null as any,
  helper: null as any
})

const errorsRowForm = reactive({
  conductor: '',
  driver: '',
  helper: ''
})

const validate = (field: 'conductor' | 'driver' | 'helper') => {
  schemaRowForm
    .validateAt(field, rowForm)
    .then((res) => {
      errorsRowForm[field] = ''
    })
    .catch((err) => {
      errorsRowForm[field] = err.message
    })
}

const attrModalConfirmation = reactive({
  show: false,
  title: 'Kembalikan Stok?',
  subTitle: '',
  subTitleHtml: true,
  btnSubmitTitle: 'Kembalikan Stok',
  btnBackTitle: 'Kembali',
  imgContent: require('@/assets/img/modal-confirmation/snack-confirmation.svg')
})

const modalConfirmation = reactive({
  show: false,
  imgContent: require('@/assets/img/modal-confirmation/roster-confirmation.svg'),
  title: '',
  subTitle: '',
  btnSubmitTitle: 'OK',
  subTitleHtml: false,
  isDelete: false
})

const editPlottingModalConfirmation = reactive({
  show: false,
  imgContent: require('@/assets/img/modal-confirmation/delete-failed.svg'),
  title: '',
  subTitle: '',
  btnSubmitTitle: 'OK',
  subTitleHtml: false,
  isDelete: false
})

const modalConfirmResetRoster = reactive({
  show: false,
  imgContent: require('@/assets/img/modal-confirmation/reset-roster-confirmation.png'),
  title: 'Reset Keberangkatan?',
  subTitle: 'Reset keberangkatan akan menghapus data transaksi saat ini dan membuat ulang data transaksi yang baru.',
  btnSubmitTitle: 'Lanjut Reset',
  subTitleHtml: false,
  isDelete: false
})

const onEditRow = (evt: any = null, val: IPlotting, index: any) => {
  loadPositionIds()
  console.log('onEditRow', val.CondecturId)
  if (isNull(val.CondecturId)) {
    isRoster.value = false
  } else {
    isRoster.value = true
  }
  console.log('isRoster', isRoster.value)
  // eslint-disable-next-line no-use-before-define
  if (timeHasBeenMissed(filterDate.value, val.DepartureTime) > -(defaultEditTimeout.value)) {
    editPlottingModalConfirmation.title = 'Ooops !'
    editPlottingModalConfirmation.subTitle = 'Bus telah melebihi batas waktu edit keberangkatan, tidak bisa melakukan perubahan data'
    editPlottingModalConfirmation.show = true
  } else if (val.HasEmptySubDetail) {
    editPlottingModalConfirmation.title = 'Ooops !'
    editPlottingModalConfirmation.subTitle = 'Bus belum memiliki data keberangkatan, mohon isi data keberangkatan bus tersebut pada master trayek'
    editPlottingModalConfirmation.show = true
  } else {
    if (isRoster.value) {
      refOverlayAction.value.toggle(evt)
    }
    plottingSelected.value = index
    const isAllFilled = val.CondecturId && val.DriverId

    if (isAllFilled && val.ActiveCondecturUsername) {
      rowForm.conductor = {
        label: val.ActiveCondecturName ?? null,
        value: val.ActiveCondecturId ?? null,
        Username: val.ActiveCondecturUsername ?? null
      }
    } else if (val.CondecturUsername) {
      rowForm.conductor = {
        label: val.CondecturName ?? null,
        value: val.CondecturId ?? null,
        Username: val.CondecturUsername ?? null
      }
    } else if (val.ActiveCondecturUsername) {
      rowForm.conductor = {
        label: val.ActiveCondecturName ?? null,
        value: val.ActiveCondecturId ?? null,
        Username: val.ActiveCondecturUsername ?? null
      }
    } else {
      rowForm.conductor = null
    }
    if (val.DriverId) {
      rowForm.driver = {
        label: val.DriverName,
        value: val.DriverId
      }
    } else {
      rowForm.driver = null
    }
    if (val.HelperId) {
      rowForm.helper = {
        label: val.HelperName,
        value: val.HelperId
      }
    } else {
      rowForm.helper = null
    }
    if (val.CondecturUsername) {
      store.dispatch(`${moduleStore}/setSelectedConductor`, {
        label: val.CondecturName,
        value: val.CondecturId,
        username: val.CondecturUsername
      })
    }
    if (val.DriverId) {
      store.dispatch(`${moduleStore}/setSelectedDriver`, {
        label: val.DriverName,
        value: val.DriverId
      })
    }
    if (val.HelperId) {
      store.dispatch(`${moduleStore}/setSelectedHelper`, {
        label: val.HelperName,
        value: val.HelperId
      })
    }
    store.dispatch('setToggleMinimizeMenu', true)
  }
}

const cancelEditRow = () => {
  plottingSelected.value = null
  rowForm.conductor = null
  rowForm.helper = null
  rowForm.driver = null
  errorsRowForm.conductor = ''
  errorsRowForm.driver = ''
  errorsRowForm.helper = ''
  store.dispatch(`${moduleStore}/setSelectedConductor`, null)
  store.dispatch(`${moduleStore}/setSelectedDriver`, null)
  store.dispatch(`${moduleStore}/setSelectedHelper`, null)
}

const checkIfDriverHasSchedule = async (data: any) => {
  store.dispatch('showLoading')
  currentSchedules.value = []
  try {
    const { result, error, message } = await apiUseCase.get(`${endpoint}/Driver/${data.authUserId}${returnUrlPrams({
      custom: [['startDate', '=', filterDate.value], ['endDate', '=', filterDate.value]]
    })}`)
    if (!error) {
      if (result.DriverRosterCount > 0) {
        modalConfirmation.title = `Sopir ${result.DriverName} Sudah Mempunyai Jadwal`
        modalConfirmation.subTitle = 'Sopir sudah mempunyai jadwal, mohon cek jadwal sopir berikut ini : '
        modalConfirmation.show = true
        modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/roster-confirmation.svg')
        modalConfirmation.btnSubmitTitle = 'OK'
        currentSchedules.value = result.DriverRosters
        // console.log('sch', currentSchedules.value)
      }
    } else {
      $toast.add({
        severity: 'error',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const checkIfCondecturHasSchedule = async (data: any) => {
  store.dispatch('showLoading')
  currentSchedules.value = []
  try {
    const { result, error, message } = await apiUseCase.get(`${endpoint}/Condectur/${data.authUserId}${returnUrlPrams({
      custom: [['startDate', '=', filterDate.value], ['endDate', '=', filterDate.value]]
    })}`)
    if (!error) {
      if (result.CondecturRosterCount > 0) {
        modalConfirmation.title = `Kondektur ${result.CondecturName} Sudah Mempunyai Jadwal`
        modalConfirmation.subTitle = 'Kondektur sudah mempunyai jadwal, mohon cek jadwal kondektur berikut ini : '
        modalConfirmation.show = true
        modalConfirmation.btnSubmitTitle = 'OK'
        modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/roster-confirmation.svg')
        currentSchedules.value = result.CondecturRosters
        // console.log('sch', currentSchedules.value)
      }
    } else {
      $toast.add({
        severity: 'error',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const checkIfCondecturNotDoneDeposit = async (data: any) => {
  console.log('checkIfCondecturNotDoneDeposit', data)
  store.dispatch('showLoading')
  isValidCondectur.value = true
  currentSchedules.value = []
  try {
    const { result, error, message } = await apiUseCase.get(`${endpointTransactionPp}/Condectur-Transaction-Closed/${data.authUserId}`)
    if (!error) {
      if (result.TransactionPp.length < 2) {
        checkIfCondecturHasSchedule(data)
      } else {
        isValidCondectur.value = false
        modalConfirmation.title = 'Kondektur belum setor pendapatan'
        modalConfirmation.subTitle = 'Kondektur mempunyai setoran yang belum di approve oleh admin. Mohon cek kembali setoran kondektur lalu approve apabila kondektur sudah setor pendapatan'
        modalConfirmation.show = true
        modalConfirmation.btnSubmitTitle = 'Kembali'
        modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/delete-failed.svg')
      }
    } else {
      $toast.add({
        severity: 'error',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const onUpdateConductor = (val: any) => {
  validate('conductor')
  store.dispatch(`${moduleStore}/setSelectedConductor`, val ? {
    label: val.label,
    value: val.authUserId ?? val.value,
    username: val.username ?? val.Username
  } : null)
  checkIfCondecturNotDoneDeposit(val)
  // checkIfCondecturHasSchedule(val)
}

const onUpdateDriver = (val: any) => {
  validate('driver')
  store.dispatch(`${moduleStore}/setSelectedDriver`, val ? {
    label: val.label,
    value: val.value
  } : null)
  checkIfDriverHasSchedule(val)
}

const onUpdateHelper = (val: any) => {
  // console.log('val', val)
  // validate('helper')
  store.dispatch(`${moduleStore}/setSelectedHelper`, val ? {
    label: val.label,
    value: val.value
  } : null)
}

const saveEditRow = (data: IPlotting) => {
  console.log('data', data.CondecturId)
  console.log('isRoster', isRoster.value)
  if (isValidCondectur.value) {
    schemaRowForm
      .validate(rowForm, { abortEarly: false })
      .then(() => {
        errorsRowForm.conductor = ''
        errorsRowForm.driver = ''
        errorsRowForm.helper = ''
        const payload = {
          ...data,
          Condectur: rowForm.conductor,
          CondecturId: rowForm.conductor?.authUserId ?? rowForm.conductor?.value,
          CondecturName: rowForm.conductor?.fullName ?? rowForm.conductor?.label,
          CondecturUsername: rowForm.conductor?.fullName ?? rowForm.conductor?.label ?? rowForm.conductor?.Username,
          PlottingDate: null,
          DriverId: rowForm.driver?.authUserId ?? rowForm.driver?.value,
          DriverName: rowForm.driver?.fullName ?? rowForm.driver?.label,
          HelperId: rowForm.helper?.authUserId ?? rowForm.helper?.value,
          HelperName: rowForm.helper?.fullName ?? rowForm.helper?.label
        }
        emit('submit', payload)
        setTimeout(() => {
          cancelEditRow()
        }, 500)
      })
      .catch((err) => {
        err.inner.forEach((error: { path: 'conductor' | 'driver' | 'helper', message: any }) => {
          errorsRowForm[error.path] = error.message
        })
      })
  } else {
    modalConfirmation.title = 'Kondektur belum setor pendapatan'
    modalConfirmation.subTitle = 'Kondektur mempunyai setoran yang belum di approve oleh admin. Mohon cek kembali setoran kondektur lalu approve apabila kondektur sudah setor pendapatan'
    modalConfirmation.show = true
    modalConfirmation.btnSubmitTitle = 'Kembali'
    modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/delete-failed.svg')
  }
}

const showDropDown = (evt: any, item: any, index: any) => {
  dataRow.value = { ...item, index }
  refOverlayAction.value.toggle(evt)
}

const showSnackDropDown = (evt: any, item: any, index: any) => {
  dataRow.value = { ...item, index }
  refOverlayActionSnack.value.toggle(evt)
}

const hideEditPlottingDialog = () => {
  editPlottingModalConfirmation.show = false
}

const setDataRowOnState = () => {
  store.dispatch('storeRowDataTable', dataRow.value)
}

const onChangeStatusRoster = (evt: any) => {
  setDataRowOnState()
  refOverlayAction.value.toggle(evt)
  emit('onChangeStatusRoster')
}

const onChangeVehicleRoster = (evt: any) => {
  setDataRowOnState()
  refOverlayAction.value.toggle(evt)
  emit('onChangeVehicleRoster')
}

const onDeactivateRoster = (evt: any) => {
  setDataRowOnState()
  refOverlayAction.value.toggle(evt)
  if (dataRow.value.IsActive) {
    emit('onChangeStatusActiveRoster')
  } else {
    emit('onDeactiveRoster')
  }
}

const onChangePage = (val: PageState) => {
  emit('changePage', val)
}

const timeHasBeenMissed = (end: string, time: string) => {
  const now = moment()
  // const endDate = moment(end.toString()).format('YYYY-MM-DD')
  const endDate = end
  const duration = moment.duration(now.diff(`${endDate} ${time}`))
  return duration.asMinutes()
}

const hideConfirmDialog = () => {
  modalConfirmation.show = false
}

const onRowExpand = (evt: any) => {
  console.log('evtOn', evt)
  // console.log('exp', expandedRows.value)
}

const onRowCollapse = (evt: any) => {
  console.log('evtOff', evt)
}

const showScheduleDialogAct = (data: any, rosterId: any, ppOrder: any) => {
  selectedRit.value = {
    ...data,
    ppOrder,
    rosterId
  }
  showScheduleDialog.value = true
}

const hideScheduleDialogAct = () => {
  showScheduleDialog.value = false
  selectedRit.value = null
}

const getTimeOutEditValue = async () => {
  const response = await apiUseCase.get('settings/v1/GlobalSetting?code=BP')
  if (!response.error) {
    defaultEditTimeout.value = response.result[0].Value
    console.log('timeout', -(defaultEditTimeout.value))
  }
}

const onResetRoster = (evt: any, data: any) => {
  refOverlayAction.value.toggle(evt)
  dataRow.value = data
  // console.log('reset', data)
  setDataRowOnState()
  emit('onResetRoster')
}

const submitFromResetModal = () => {
  console.log('submitReset')
  emit('onResetRoster')
}

const showConfirmResetDialogAct = () => {
  modalConfirmResetRoster.show = true
  showConfirmResetDialog.value = true
}

const hideResetRosterModal = () => {
  modalConfirmResetRoster.show = false
  showConfirmResetDialog.value = false
  store.dispatch('storeRowDataTable', null)
}

const showDetailDropDown = (evt: any, header: any, item: any) => {
  dataRow.value = {
    ...header,
    SelectedDetail: item
  }
  refOverlayActionDetail.value.toggle(evt)
}

const manageOnlineAct = (evt: any, data: any) => {
  console.log('manageOnline', [evt, data])
}

const manageSnackAct = async (evt: any, data: any) => {
  if (timeHasBeenMissed(filterDate.value, moment(data.RosterDate).format('HH:mm:ss')) <= -(defaultEditTimeout.value)) {
    const building = await store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
    const isAdmin = store.state?.userProfile?.resource_access['hjp-microservices'].roles.includes('Admin')
    // console.log('isAdmin', isAdmin)
    if (!building && !isAdmin) {
      $toast.add({
        severity: 'error',
        summary: 'Peringatan',
        detail: 'User belum terhubung dengan gedung manapun. Silahkan hubungi Admin',
        group: 'bc',
        closable: false,
        life: 3000
      })
    } else {
      const encryptData = encryptDecriptMethods.encrypt(data)
      router.push({
        name: 'roster-snack',
        params: {
          id: encryptData
        }
      })
    }
  } else {
    $toast.add({
      severity: 'error',
      detail: 'Batas waktu untuk assign Snack Roster sudah habis!',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  // const encryptData = encryptDecriptMethods.encrypt(data)
  // router.push({
  //   name: 'roster-snack',
  //   params: {
  //     id: encryptData
  //   }
  // })
}

const returnSnackProcess = async () => {
  store.dispatch('showLoading')
  const building = await store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
  // console.log('building', building)
  if (!building) {
    $toast.add({
      severity: 'error',
      detail: 'User tidak terhubung dengan gedung manapun',
      group: 'bc',
      life: 3000
    })
  } else {
    // console.log('store', store.state)
    console.log('selectedDataForReturnSnack', selectedDataForReturnSnack.value)
    // const payload = {
    //   FromBuildingId: null,
    //   FromBuildingName: null,
    //   ToBuildingId: building.id ?? null,
    //   ToBuildingName: building.name ?? null,
    //   ReferenceId: dataRow.value?.Id,
    //   TransferType: 'ReturnFromRoster',
    //   SnackTransferItems: [] as any
    // }
    // // eslint-disable-next-line no-unused-expressions, array-callback-return
    // payload.SnackTransferItems = selectedDataForReturnSnack.value?.SnackTransferItems.map((data: any) => ({
    //   SnackId: data.SnackId,
    //   Quantity: data.Quantity
    // }))
    const payload = {
      Status: 'Rejected'
    }
    try {
      await apiOpenUseCase.patchWithNoId(`${snackEndpoint}/Transfer/ByReference/${dataRow.value?.Id}/Status`, payload).then((response) => {
        const { result, error, message } = response
        if (!error) {
          $toast.add({
            severity: 'success',
            summary: 'Stok snack berhasil dikembalikan!',
            detail: 'Cek Master Snack untuk melihat jumlah stok yang dikembalikan',
            group: 'bc',
            life: 3000
          })
          // eslint-disable-next-line no-use-before-define
          hideDialogReturnSnackConfirmation()
          // getAllData()
        } else {
          $toast.add({
            severity: 'error',
            summary: 'Gagal menyetor snack',
            detail: message,
            group: 'bc',
            life: 3000
          })
        }
      })
    } catch (error) {
      $toast.add({
        severity: 'error',
        summary: 'Gagal menyimpan snack',
        detail: error,
        group: 'bc',
        life: 3000
      })
    }
  }
  store.dispatch('hideLoading')
}

const hideDialogReturnSnackConfirmation = () => {
  attrModalConfirmation.show = false
  selectedDataForReturnSnack.value = null
}

const showDialogConfirmation = (data: any) => {
  // console.log('ss', data)
  selectedDataForReturnSnack.value = data
  attrModalConfirmation.subTitle = 'Snack yang dikembalikan akan masuk ke stok snack kumulatif.'
  attrModalConfirmation.show = true
}

const returnSnackAct = () => {
  store.dispatch('showLoading')
  apiOpenUseCase.get(`${snackEndpoint}/Transfer/ByReference/${dataRow.value.Id}`).then((response) => {
    console.log('snackList', response)
    const { result, error } = response
    if (!error) {
      showDialogConfirmation(result)
      store.dispatch('hideLoading')
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Roster belum memiliki snack',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  getTimeOutEditValue()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      expandedRows: expandedRowsList.value,
      "onUpdate:expandedRows": _cache[3] || (_cache[3] = ($event: any) => ((expandedRowsList).value = $event)),
      value: _unref(plottingList),
      rows: 5,
      dataKey: "index",
      loading: _unref(isLoading),
      class: "excel-clone overflow-x-auto",
      responsiveLayout: "scroll"
    }, {
      empty: _withCtx(() => [
        _hoisted_2
      ]),
      loading: _withCtx(() => [
        _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
      ]),
      expansion: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_unref(DataTable), {
            value: slotProps.data.RosterDetails,
            class: "excel-clone inner-table",
            responsiveLayout: "scroll"
          }, {
            empty: _withCtx(() => [
              _hoisted_33
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(Column), {
                header: "Urutan RIT",
                style: {"width":"120px"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(`RIT ${data.RitOrder}`), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), { header: "Nama RIT" }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(data.MsRouteName), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), { header: "T. Awal - T. Akhir" }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_36, _toDisplayString(`${data.RitDepartureTerminal ?? '-'} - ${data.RitArrivalTerminal ?? '-'}`), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), { header: "Jam Brngkt - Jam Dtg" }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(`${data.RitDepartureTime ? data.RitDepartureTime.slice(0, 5) : '--:--'} - ${data.RitArrivalTime ? data.RitArrivalTime.slice(0, 5) : '--:--'}`), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                header: "Total Belum Check In",
                style: {"width":"150px"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("p", _hoisted_39, _toDisplayString(`${data.SeatBooking - data.SeatCheckin}`), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                header: "Total Tiket Terjual",
                style: {"width":"120px"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("p", _hoisted_41, _toDisplayString(data.SeatBooking), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), { header: "Aksi" }, {
                body: _withCtx(({ data }) => [
                  (slotProps.data.RosterDetails[0]?.Id === defaultGuid.value)
                    ? (_openBlock(), _createBlock(_unref(Popper), {
                        key: 0,
                        arrow: "",
                        hover: "",
                        placement: "left",
                        content: 'Rit tidak memiliki jadwal. Silahkan lengkapi jadwal terlebih dahulu.'
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42
                        ]),
                        _: 1
                      }, 8, ["content"]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "#",
                        class: "btn-detail",
                        onClick: _withModifiers(($event: any) => (showScheduleDialogAct(data, slotProps.data.Id, slotProps.data.PpOrder)), ["prevent"])
                      }, _hoisted_46, 8, _hoisted_43))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["value"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          expander: "",
          style: {"width":"5rem"}
        }),
        _createVNode(_unref(Column), {
          field: "RegNumber",
          header: "Nopol",
          style: {"width":"110px","min-width":"110px"}
        }, {
          body: _withCtx(({ data, field }) => [
            _createElementVNode("p", {
              class: _normalizeClass(!data.IsActive ? 'text-grey' : '')
            }, _toDisplayString(data[field]), 3)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "PP",
          style: {"width":"100px","min-width":"100px"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  class: _normalizeClass(!data.IsActive ? 'text-grey' : '')
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(!data.IsActive ? 'text-grey font-bold' : 'text-base font-bold')
                  }, _toDisplayString(`PP${data.Pp}`), 3),
                  _createTextVNode(" " + _toDisplayString(`(${data.DepartureTime.slice(0, 5)})`), 1)
                ], 2),
                (data.RosterStatusCode === 'GBG' || data.MsStatusRoster?.Code === 'GBG')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(data.RosterStatusName ?? data.MsStatusRoster?.Name), 1))
                  : (data.RosterStatusCode === 'RGL' || data.MsStatusRoster?.Code === 'RGL')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(data.RosterStatusName ?? data.MsStatusRoster?.Name), 1))
                    : (data.RosterStatusCode === 'PRW' || data.MsStatusRoster?.Code === 'PRW')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(data.RosterStatusName ?? data.MsStatusRoster?.Name), 1))
                      : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_7, _toDisplayString(data.DepartureAt ? `Berangkat (${_unref(moment)(data.DepartureAt).format('HH:mm')})` : ''), 1)
              ]),
              _createElementVNode("div", null, [
                (data.IsNonactiveRoster)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                  : _createCommentVNode("", true),
                (data.IsVerpal)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Snack",
          style: {"width":"140px","min-width":"140px"}
        }, {
          body: _withCtx((slotProps) => [
            (Boolean(slotProps.data?.CondecturId))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: ($event: any) => (showSnackDropDown($event, slotProps.data, slotProps.index)),
                  class: "cursor-pointer font-bold text-sm rounded-lg py-1 px-2 background-blue-4 text-primary border-primary"
                }, _hoisted_13, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Seat",
          style: {"width":"75px","min-width":"75px"}
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.SeatCapacity ?? '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "Condectur",
          header: "Kondektur",
          style: {"width":"220px","min-width":"210px"}
        }, {
          body: _withCtx((slotProps) => [
            (_unref(plottingSelected) === slotProps.index)
              ? (_openBlock(), _createBlock(SelectAsyncOpen, {
                  key: 0,
                  endpoint: "/talent/v1/employees",
                  searchCustom: [['latestEmployment.PositionIds', '=', _unref(positionIds).conductor]],
                  searchFields: ['fullName'],
                  fieldLabel: (v) => v.fullName,
                  fieldValue: 'authUserId',
                  modelValue: rowForm.conductor,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((rowForm.conductor) = $event)),
                    onUpdateConductor
                  ],
                  placeholder: slotProps.data.ActiveCondecturName ? slotProps.data.ActiveCondecturName : 'Pilih Kondektur',
                  classname: 'custom-select',
                  class: _normalizeClass(errorsRowForm.conductor ? 'select-invalid' : ''),
                  title: rowForm.conductor?.label || rowForm.conductor?.fullName || slotProps.data.ActiveCondecturName || '',
                  selectable: (v) => v.authUserId,
                  "append-to-body": true,
                  "calculate-position": calculateDropdownPosition
                }, {
                  option: _withCtx((option) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["w-full truncate", !option.authUserId ? 'text-neutral-400 cursor-not-allowed' : '']),
                      title: !option.authUserId ? 'User belum terhubung dengan SSO' : option.fullName
                    }, _toDisplayString(option.fullName), 11, _hoisted_14)
                  ]),
                  _: 2
                }, 1032, ["searchCustom", "fieldLabel", "modelValue", "placeholder", "class", "title", "selectable"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (slotProps.data.CondecturId !== slotProps.data.ActiveCondecturId)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                        _createElementVNode("s", null, _toDisplayString(slotProps.data.CondecturName ?? '-'), 1),
                        _hoisted_17,
                        _createElementVNode("b", _hoisted_18, _toDisplayString(slotProps.data.ActiveCondecturName), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        class: _normalizeClass(!slotProps.data.IsActive ? 'text-grey' : '')
                      }, _toDisplayString(slotProps.data.CondecturName ?? '-'), 3))
                ]))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "Driver",
          header: "Pengemudi",
          style: {"width":"220px","min-width":"210px"}
        }, {
          body: _withCtx((slotProps) => [
            (_unref(plottingSelected) === slotProps.index)
              ? (_openBlock(), _createBlock(SelectAsyncOpen, {
                  key: 0,
                  endpoint: "/talent/v1/employees",
                  searchCustom: [['latestEmployment.PositionIds', '=', _unref(positionIds).driver]],
                  searchFields: ['fullName'],
                  fieldLabel: (v) => v.fullName,
                  fieldValue: 'authUserId',
                  modelValue: rowForm.driver,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((rowForm.driver) = $event)),
                    onUpdateDriver
                  ],
                  placeholder: slotProps.data.DriverName ? slotProps.data.DriverName : 'Pilih Pengemudi',
                  classname: 'custom-select',
                  class: _normalizeClass(errorsRowForm.driver ? 'select-invalid' : ''),
                  title: rowForm.driver?.label || rowForm.driver?.fullName || slotProps.data.DriverName || '',
                  selectable: (v) => v.authUserId,
                  "append-to-body": true,
                  "calculate-position": calculateDropdownPosition
                }, {
                  option: _withCtx((option) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["w-full truncate", !option.authUserId ? 'text-neutral-400 cursor-not-allowed' : '']),
                      title: !option.authUserId ? 'User belum terhubung dengan SSO' : option.fullName
                    }, _toDisplayString(option.fullName), 11, _hoisted_19)
                  ]),
                  _: 2
                }, 1032, ["searchCustom", "fieldLabel", "modelValue", "placeholder", "class", "title", "selectable"]))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass(!slotProps.data.IsActive ? 'text-grey' : '')
                }, _toDisplayString(slotProps.data.DriverName ?? '-'), 3))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "Helper",
          header: "Helper",
          style: {"width":"220px","min-width":"210px"}
        }, {
          body: _withCtx((slotProps) => [
            (_unref(plottingSelected) === slotProps.index)
              ? (_openBlock(), _createBlock(SelectAsyncOpen, {
                  key: 0,
                  endpoint: "/talent/v1/employees",
                  searchCustom: [['latestEmployment.PositionIds', '=', _unref(positionIds).helper]],
                  searchFields: ['fullName'],
                  fieldLabel: (v) => v.fullName,
                  fieldValue: 'authUserId',
                  modelValue: rowForm.helper,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((rowForm.helper) = $event)),
                    onUpdateHelper
                  ],
                  placeholder: slotProps.data.HelperName ? slotProps.data.HelperName : 'Pilih Helper',
                  classname: 'custom-select',
                  class: _normalizeClass(errorsRowForm.helper ? 'select-invalid' : ''),
                  title: rowForm.helper?.label || rowForm.helper?.fullName || slotProps.data.HelperName || '',
                  selectable: (v) => v.authUserId,
                  "append-to-body": true,
                  "calculate-position": calculateDropdownPosition
                }, {
                  option: _withCtx((option) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["w-full truncate", !option.authUserId ? 'text-neutral-400 cursor-not-allowed' : '']),
                      title: !option.authUserId ? 'User belum terhubung dengan SSO' : option.fullName
                    }, _toDisplayString(option.fullName), 11, _hoisted_20)
                  ]),
                  _: 2
                }, 1032, ["searchCustom", "fieldLabel", "modelValue", "placeholder", "class", "title", "selectable"]))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass(!slotProps.data.IsActive ? 'text-grey' : '')
                }, _toDisplayString(slotProps.data.HelperName ?? '-'), 3))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Aksi",
          bodyStyle: "text-align:center",
          style: {"width":"120px","min-width":"120px"}
        }, _createSlots({ _: 2 }, [
          (_unref(isEdit))
            ? {
                name: "body",
                fn: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_21, [
                    (_unref(plottingSelected) === slotProps.index)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "cancel",
                            class: "cursor-pointer shrink-0",
                            style: {"width":"37px","height":"37px","min-width":"37px"},
                            onClick: cancelEditRow
                          }),
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "save",
                            class: "cursor-pointer shrink-0",
                            style: {"width":"37px","height":"37px","min-width":"37px"},
                            onClick: ($event: any) => (saveEditRow(slotProps.data))
                          }, null, 8, _hoisted_23)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(plottingSelected) !== slotProps.index && !slotProps.data.CondecturId)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "inline-flex rounded-md bg-neutral-100 gap-2 items-center px-2 py-1 cursor-pointer",
                          onClick: ($event: any) => (onEditRow(null, slotProps.data, slotProps.index))
                        }, _hoisted_27, 8, _hoisted_24))
                      : _createCommentVNode("", true),
                    (Boolean(slotProps.data?.CondecturId) && _unref(plottingSelected) !== slotProps.index && slotProps.data.CondecturId && timeHasBeenMissed(_unref(filterDate), slotProps.data.DepartureTime) <= -(defaultEditTimeout.value))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "inline-flex rounded-md bg-neutral-100 gap-2 items-center px-2 py-1 cursor-pointer",
                          onClick: ($event: any) => (showDropDown($event, slotProps.data, slotProps.index))
                        }, _hoisted_31, 8, _hoisted_28))
                      : _createCommentVNode("", true)
                  ])
                ])
              }
            : undefined
        ]), 1024)
      ]),
      _: 1
    }, 8, ["expandedRows", "value", "loading"]),
    (_unref(plottingList).length > 0)
      ? (_openBlock(), _createBlock(Paginator, {
          key: 0,
          rows: 10,
          totalRecords: _unref(totalRecords),
          onOnPage: onChangePage,
          template: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        }, null, 8, ["totalRecords"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction
    }, {
      default: _withCtx(() => [
        _createVNode(ListActions, {
          editRoster: isRoster.value ? _unref(dataRow).IsActive : true,
          changeStatusRoster: isRoster.value ? _unref(dataRow).IsActive : true,
          changeVehicleRoster: isRoster.value && _unref(checkProhibitedRoles)(['Roster']) ? _unref(dataRow).IsActive : true,
          deactiveRoster: true,
          editRosterTitle: editRosterTitle.value,
          changeStatusRosterTitle: changeStatusRosterTitle.value,
          changeVehicleRosterTitle: changeVehicleRosterTitle.value,
          deactiveRosterTitle: _unref(dataRow).IsActive ? 'Non Aktif' : 'Aktif',
          onDeactiveRoster: _cache[4] || (_cache[4] = ($event: any) => (onDeactivateRoster($event))),
          onEditRoster: _cache[5] || (_cache[5] = ($event: any) => (onEditRow($event, _unref(dataRow), _unref(dataRow).index))),
          onChangeStatusRoster: _cache[6] || (_cache[6] = ($event: any) => (onChangeStatusRoster($event))),
          onChangeVehicleRoster: _cache[7] || (_cache[7] = ($event: any) => (onChangeVehicleRoster($event))),
          "manage-snack": false,
          onManageSnack: _cache[8] || (_cache[8] = ($event: any) => (_unref(dataRow).IsAlreadyDeparture ? _ctx.$router.push({ name: 'roster-snack-detail', params: {id: _unref(encryptDecriptMethods).encrypt(_unref(dataRow))} }) : manageSnackAct($event, _unref(dataRow))))
        }, null, 8, ["editRoster", "changeStatusRoster", "changeVehicleRoster", "editRosterTitle", "changeStatusRosterTitle", "changeVehicleRosterTitle", "deactiveRosterTitle"])
      ]),
      _: 1
    }, 512),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayActionDetail",
      ref: refOverlayActionDetail
    }, {
      default: _withCtx(() => [
        _createVNode(RosterDetailActions, {
          detail: true,
          onDetail: _cache[9] || (_cache[9] = ($event: any) => (showScheduleDialogAct(_unref(dataRow), _unref(dataRow).Id, _unref(dataRow).PpOrder))),
          "manage-online": false,
          onManageOnline: _cache[10] || (_cache[10] = ($event: any) => (manageOnlineAct($event, _unref(dataRow)))),
          "manage-snack": false,
          onManageSnack: _cache[11] || (_cache[11] = ($event: any) => (_unref(dataRow).IsAlreadyDeparture ? _ctx.$router.push({ name: 'roster-snack-detail', params: {id: _unref(encryptDecriptMethods).encrypt(_unref(dataRow))} }) : manageSnackAct($event, _unref(dataRow))))
        })
      ]),
      _: 1
    }, 512),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayActionSnack",
      ref: refOverlayActionSnack
    }, {
      default: _withCtx(() => [
        _createVNode(RosterSnackActions, {
          addSnack: Boolean(_unref(dataRow).CondecturId) && Boolean(!_unref(dataRow).IsAlreadyDeparture) && timeHasBeenMissed(_unref(filterDate), _unref(dataRow).DepartureTime) <= -(defaultEditTimeout.value),
          onAddSnack: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push({ name: `${_unref(dataRow).IsAlreadyDeparture || timeHasBeenMissed(_unref(filterDate), _unref(dataRow).DepartureTime) <= -(defaultEditTimeout.value) ? 'roster-snack' : 'roster-snack-detail'}`, params: {id: _unref(encryptDecriptMethods).encrypt(_unref(dataRow))} }))),
          detailSnack: Boolean(_unref(dataRow).CondecturId),
          onDetailSnack: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push({ name: 'roster-snack-detail', params: {id: _unref(encryptDecriptMethods).encrypt(_unref(dataRow))} }))),
          returnSnack: Boolean(_unref(dataRow).CondecturId) && (timeHasBeenMissed(_unref(filterDate), _unref(dataRow).DepartureTime) > 0 && Boolean(!_unref(dataRow).IsAlreadyDeparture)),
          onReturnSnack: returnSnackAct
        }, null, 8, ["addSnack", "detailSnack", "returnSnack"])
      ]),
      _: 1
    }, 512),
    _createVNode(HjpAlertModal, {
      show: modalConfirmation.show,
      title: modalConfirmation.title,
      subTitle: modalConfirmation.subTitle,
      subTitleHtml: modalConfirmation.subTitleHtml,
      btnSubmitTitle: modalConfirmation.btnSubmitTitle,
      imgContent: modalConfirmation.imgContent,
      onHideDialog: hideConfirmDialog,
      onOnSubmit: hideConfirmDialog
    }, _createSlots({ _: 2 }, [
      (_unref(currentSchedules).length > 0)
        ? {
            name: "additionalContent",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentSchedules), (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data,
                    class: "w-full grid grid-cols-2 gap-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_49, _toDisplayString(data.RegNumber), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_50, _toDisplayString(`PP${data.PpOrder} (${data.DepartureTime})`), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          }
        : undefined
    ]), 1032, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent"]),
    (showScheduleDialog.value)
      ? (_openBlock(), _createBlock(InfoScheduleDialog, {
          key: 1,
          show: showScheduleDialog.value,
          ritData: _unref(selectedRit),
          onHideScheduleForm: hideScheduleDialogAct
        }, null, 8, ["show", "ritData"]))
      : _createCommentVNode("", true),
    _createVNode(HjpAlertModal, {
      show: editPlottingModalConfirmation.show,
      title: editPlottingModalConfirmation.title,
      subTitle: editPlottingModalConfirmation.subTitle,
      subTitleHtml: editPlottingModalConfirmation.subTitleHtml,
      btnSubmitTitle: editPlottingModalConfirmation.btnSubmitTitle,
      imgContent: editPlottingModalConfirmation.imgContent,
      onHideDialog: hideEditPlottingDialog,
      onOnSubmit: hideEditPlottingDialog
    }, null, 8, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent"]),
    (showConfirmResetDialog.value)
      ? (_openBlock(), _createBlock(HjpConfirmationModal, {
          key: 2,
          show: modalConfirmResetRoster.show,
          title: modalConfirmResetRoster?.title,
          imgContent: modalConfirmResetRoster.imgContent,
          subTitle: modalConfirmResetRoster?.subTitle,
          btnSubmitTitle: modalConfirmResetRoster?.btnSubmitTitle,
          onHideDialog: hideResetRosterModal,
          onOnSubmit: submitFromResetModal
        }, null, 8, ["show", "title", "imgContent", "subTitle", "btnSubmitTitle"]))
      : _createCommentVNode("", true),
    _createVNode(HjpConfirmationModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      subTitleHtml: attrModalConfirmation.subTitleHtml,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      btnBackTitle: attrModalConfirmation.btnBackTitle,
      onHideDialog: hideDialogReturnSnackConfirmation,
      onOnSubmit: returnSnackProcess
    }, null, 8, ["show", "imgContent", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "btnBackTitle"])
  ]))
}
}

})